import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CoreServiceService } from './core/core-service.service';
import { MasterUser } from './Models/master-user';
import { Status } from './Models/status';
import { Tchgpwd } from './Models/tchgpwd';

@Injectable({
  providedIn: 'root'
})
export class UserApiService {

  private BaseApiPath: string;
  constructor(private http: HttpClient, private coreService: CoreServiceService) {

    this.BaseApiPath = this.coreService.appSettings && this.coreService.appSettings.ParkBaseApiPath;
  }
  public getUserCategories(): Observable<MasterUser[]> {
    const ApiUrl = this.BaseApiPath + 'user/getUsers';
    return this.http.get<MasterUser[]>(ApiUrl);
  }

  public InsertUpdateUser(masterUser: MasterUser): Observable<Status<string>> {
    const ApiUrl = this.BaseApiPath + 'user/insertUpdateUser';
    return this.http.post<Status<string>>(ApiUrl, masterUser);
  }

  public getUser(masterUser: MasterUser): Observable<MasterUser> {
    const ApiUrl = this.BaseApiPath + 'user/getUser';
    return this.http.post<MasterUser>(ApiUrl, masterUser);
  }

  public loginUser(masterUser: MasterUser): Observable<MasterUser> {
    const ApiUrl = this.BaseApiPath + 'user/loginUser';
    return this.http.post<MasterUser>(ApiUrl, masterUser);
  }

  public getBaseApiPathTest() {
    return this.BaseApiPath;
  }

  public changeUserTempPwd(tchgpwd: Tchgpwd): Observable<Status<string>> {
    const ApiUrl = this.BaseApiPath + 'user/changeUserTempPwd';
    return this.http.post<Status<string>>(ApiUrl, tchgpwd);
  }

}
